<ng-template #addNewsletterDialogTemplateRef>
  <app-mediego-confirmation-dialog [dialogTitle]="'MAIN.APP.DIALOGS.ADD_NEWSLETTER.TITLE' | translate"
    icon="add_circle_outline"
    class="add-newsletter-dialog"
    [acceptLabel]="'SHARED.BUTTONS.ADD' | translate"
    [declineLabel]="'SHARED.BUTTONS.CANCEL' | translate"
    [resultData]="addNewsletterForm.value">
    <form [formGroup]="addNewsletterForm">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'MAIN.APP.DIALOGS.ADD_WEBSOURCE.INPUT.NAME' | translate }}</mat-label>
        <input matInput type="text" formControlName="name">
      </mat-form-field>

      <hr/>

      @if (duplicateEmailSourceSelectShown) {
        <mat-form-field  appearance="outline">
          <mat-label>{{ 'MAIN.APP.DIALOGS.DUPLICATE_NEWSLETTER.INPUT.ENGINE' | translate }}</mat-label>
          <mat-select formControlName="fromEngineId" (selectionChange)="updateSourceListForDuplication('email', $event.value)">
            @for (engine of engineListForDuplication; track engine) {
              <mat-option [value]="engine[1]">{{ engine[0] }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field  appearance="outline">
          <mat-label>{{ 'MAIN.APP.DIALOGS.DUPLICATE_NEWSLETTER.INPUT.NAME' | translate }}</mat-label>
          <mat-select formControlName="duplicationId">
            <mat-option value=""></mat-option>
            @for (newsletter of newsletterListForDuplication; track newsletter) {
              <mat-option [value]="newsletter[1]">{{ newsletter[0] }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      } @else {
        <button mat-flat-button (click)="enableDuplicateField()">
          {{ 'MAIN.APP.DIALOGS.DUPLICATE_NEWSLETTER.BUTTON' | translate }}
        </button>
      }
    </form>
  </app-mediego-confirmation-dialog>
</ng-template>

<ng-template #addWebSourceDialogTemplateRef>
  <app-mediego-confirmation-dialog [dialogTitle]="'MAIN.APP.DIALOGS.ADD_WEBSOURCE.TITLE' | translate"
    icon="add_circle_outline"
    [acceptLabel]="'SHARED.BUTTONS.ADD' | translate"
    [declineLabel]="'SHARED.BUTTONS.CANCEL' | translate"
    [resultData]="addWebSourceForm.value">
    <form [formGroup]="addWebSourceForm">
      <mat-form-field appearance="outline" mat-dialog-content>
        <mat-label>{{ 'MAIN.APP.DIALOGS.ADD_WEBSOURCE.INPUT.NAME' | translate }}</mat-label>
        <input matInput type="text" formControlName="name">
      </mat-form-field>
    </form>
  </app-mediego-confirmation-dialog>
</ng-template>

<ng-template #moveSourceDialogTemplateRef>
  <app-mediego-confirmation-dialog [dialogTitle]="'MAIN.APP.DIALOGS.MOVE_WEBSOURCE.TITLE' | translate"
    icon="add_circle_outline"
    [acceptLabel]="'SHARED.BUTTONS.SAVE' | translate"
    [declineLabel]="'SHARED.BUTTONS.CANCEL' | translate"
    [resultData]="nameInput.value">
    <mat-form-field appearance="outline" mat-dialog-content>
      <mat-label>{{ 'MAIN.APP.DIALOGS.MOVE_WEBSOURCE.INPUT.NAME' | translate }}</mat-label>
      <input matInput type="text" #nameInput>
    </mat-form-field>
  </app-mediego-confirmation-dialog>
</ng-template>

@if (nbOfTabs > 0) {
  <div id="sideNavBreadcrumbs" fxLayout="row" fxLayoutAlign="start baseline">
    <button id="home-tab-crumb" mat-button color="primary" tabindex="-1"
      (click)="goToTab(0)">
      <mat-icon>home</mat-icon>
    </button>
    <ng-container *ngTemplateOutlet="chevronTemplate"></ng-container>
    @if (nbOfTabs > 1) {
      <button id="parent-folder-crumb" mat-button color="primary" tabindex="-1"
        (click)="goToTab(selectedTabIndex - 1)" matTooltipPosition="above"
        [matTooltip]="previousTab?.name | translate">
        <mat-icon>folder_outline</mat-icon>
      </button>
      <ng-container *ngTemplateOutlet="chevronTemplate"></ng-container>
    }
    <button mat-button disabled id="current-folder-crumb" color="primary" tabindex="-1">
      {{ selectedTab?.name | translate }}
    </button>
    <ng-template #chevronTemplate>
      <button mat-icon-button class="crumb-chevron" disabled>
        <mat-icon>chevron_right</mat-icon>
      </button>
    </ng-template>
  </div>
}

@if (allTabs$ | async; as allTabs) {
  <div id="navigation-tabs" fxLayout="row">
    <mat-tab-group [selectedIndex]="selectedTabIndex$$ | async" animationDuration="0">
      @for (tab of allTabs; track tab) {
        <mat-tab>
          <ng-template matTabContent>
            @if (tab) {
              @if (selectedEngine$ | async; as selectedEngine) {
                <mat-nav-list fxLayout="column">
                  <!-- STATIC ITEMS -->
                  <!-- Newsletters -->
                  @if (tab.name === 'MAIN.APP.SIDEBAR.NEWSLETTERS.TITLE') {
                    <!-- ALL -->
                    @if (isEngineAdmin$ | async) {
                      <a mat-list-item data-intercom-target="email_supervisor_button" (click)="shouldCloseSidebar.emit()" routerLink="/newsletters/supervisor" queryParamsHandling="preserve" routerLinkActive="active">
                        <mat-icon color="accent">table_view</mat-icon> {{ 'SHARED.SUPERVISOR' | translate }}
                      </a>
                    }
                    <!-- STATS -->
                    <a mat-list-item data-intercom-target="email_stats_button" (click)="shouldCloseSidebar.emit()"
                      [routerLink]="['/newsletters', ALL_EMAILING_SOURCES.id, 'stats']" queryParamsHandling="preserve" routerLinkActive="active">
                      <mat-icon>bar_chart</mat-icon>{{ ALL_EMAILING_SOURCES.displayName | translate }}
                    </a>
                    <!-- HISTORY -->
                    <a mat-list-item data-intercom-target="email_history_button" (click)="shouldCloseSidebar.emit()"
                      [routerLink]="['/newsletters', ALL_EMAILING_HISTORY.id, 'history']" queryParamsHandling="preserve" routerLinkActive="active">
                      <mat-icon>timeline</mat-icon>{{ ALL_EMAILING_HISTORY.displayName | translate }}
                    </a>
                  }
                  <!-- Web Sources -->
                  @if (tab.name === 'MAIN.APP.SIDEBAR.WEB_PERSO.TITLE') {
                    @if (isEngineAdmin$ | async) {
                      <a mat-list-item data-intercom-target="web_personalisation_create_button" (click)="openDialog('web')">
                        <mat-icon color="accent">add</mat-icon>
                        {{ 'MAIN.APP.SIDEBAR.WEB_PERSO.ADD' | translate }}
                      </a>
                      <a mat-list-item data-intercom-target="web_personalisation_stats_button" (click)="shouldCloseSidebar.emit()"
                        [routerLink]="['/web-personalisation', ALL_PERSONALISATION_SOURCES.id, 'stats']" queryParamsHandling="preserve" routerLinkActive="active">
                        <mat-icon color="accent">bar_chart</mat-icon>{{ ALL_PERSONALISATION_SOURCES.displayName | translate }}
                      </a>
                    }
                  }
                  <!-- CRM -->
                  @if (tab.name === 'MAIN.APP.SIDEBAR.CRM.TITLE') {
                    <a mat-list-item routerLink="/crm/contacts" queryParamsHandling="merge" [queryParams]="{ segmentId: null }" (click)="shouldCloseSidebar.emit()">
                      <mat-icon>import_contacts</mat-icon>{{ 'MAIN.APP.SIDEBAR.CRM.CONTACTS' | translate }}
                    </a>
                    <a mat-list-item routerLink="/crm/segments" queryParamsHandling="preserve" (click)="shouldCloseSidebar.emit()">
                      <mat-icon>list_alt</mat-icon>{{ 'MAIN.APP.SIDEBAR.CRM.SEGMENTS' | translate }}
                    </a>
                    <a mat-list-item routerLink="/crm/forms" queryParamsHandling="preserve" (click)="shouldCloseSidebar.emit()">
                      <mat-icon>assignment</mat-icon>{{ 'MAIN.APP.SIDEBAR.CRM.FORMS' | translate }}
                    </a>
                  }
                  <!-- Contents -->
                  @if (tab.name === 'MAIN.APP.SIDEBAR.CONTENTS.TITLE') {
                    @if (selectedEngine.userPermissions.configurations.itemSets) {
                      <a mat-list-item routerLink="/contents/itemfeeds" queryParamsHandling="preserve" routerLinkActive="active" (click)="shouldCloseSidebar.emit()" >
                        <mat-icon>feed</mat-icon>{{ 'MAIN.APP.SIDEBAR.CONTENTS.FLUX' | translate }}
                      </a>
                      <a mat-list-item routerLink="/contents/itemsets" queryParamsHandling="preserve" routerLinkActive="active" (click)="shouldCloseSidebar.emit()" >
                        <mat-icon>category</mat-icon>{{ 'MAIN.APP.SIDEBAR.CONTENTS.SOURCES' | translate }}
                      </a>
                      <a mat-list-item routerLink="/contents/explore" queryParamsHandling="preserve" routerLinkActive="active" (click)="shouldCloseSidebar.emit()" >
                        <mat-icon>search</mat-icon>{{ 'MAIN.APP.SIDEBAR.CONTENTS.EXPLORE' | translate }}
                      </a>
                    }
                    <!-- Gestion globale -->
                    @if (isAdmin$ | async) {
                      <a mat-list-item routerLink="/contents/supervisor" queryParamsHandling="preserve" routerLinkActive="active" (click)="shouldCloseSidebar.emit()">
                        <mat-icon class="admin-color">table_view</mat-icon> {{ 'SHARED.SUPERVISOR' | translate }}
                      </a>
                    }
                  }
                  <!-- Configuration / Administration -->
                  @if (tab.name === 'MAIN.APP.SIDEBAR.CONFIGURATION.TITLE') {
                    @if (selectedEngine.userPermissions.configurations.integration) {
                      <a mat-list-item routerLink="/configuration/engine" routerLinkActive="active" (click)="shouldCloseSidebar.emit()" queryParamsHandling="preserve">
                        <mat-icon>public</mat-icon>{{ 'MAIN.APP.SIDEBAR.CONFIGURATION.DOMAIN' | translate }}
                      </a>
                    }
                    @if (selectedEngine.userPermissions.configurations.accessManagement) {
                      <a mat-list-item routerLink="/configuration/access-management" routerLinkActive="active" (click)="shouldCloseSidebar.emit()" queryParamsHandling="preserve">
                        <mat-icon>group</mat-icon>{{ 'MAIN.APP.SIDEBAR.CONFIGURATION.ACCESS_MANAGEMENT.TITLE' | translate }}
                      </a>
                    }
                    @if (selectedEngine.userPermissions.configurations.newsletters && (isEngineAdmin$ | async)) {
                      <a mat-list-item routerLink="/configuration/newsletters-config" routerLinkActive="active" (click)="shouldCloseSidebar.emit()" queryParamsHandling="preserve">
                        <mat-icon>style</mat-icon>{{ 'MAIN.APP.SIDEBAR.CONFIGURATION.NEWSLETTERS' | translate }}
                      </a>
                    }
                    @if (isAdmin$ | async) {
                      <a mat-list-item routerLink="/configuration/modules" routerLinkActive="active" (click)="shouldCloseSidebar.emit()" queryParamsHandling="preserve">
                        <mat-icon class="admin-color">rule</mat-icon>Modules
                      </a>
                      <a mat-list-item routerLink="/configuration/scrapers" routerLinkActive="active" (click)="shouldCloseSidebar.emit()" queryParamsHandling="preserve">
                        <mat-icon class="admin-color">settings</mat-icon>Scrapers
                      </a>
                      <a mat-list-item routerLink="/configuration/audience-management" routerLinkActive="active" (click)="shouldCloseSidebar.emit()" queryParamsHandling="preserve">
                        <mat-icon class="admin-color">send</mat-icon>{{ 'MAIN.APP.SIDEBAR.CONFIGURATION.AUDIENCE' | translate }}
                      </a>
                      <a mat-list-item routerLink="/monitoring" routerLinkActive="active" (click)="shouldCloseSidebar.emit()" queryParamsHandling="preserve">
                        <mat-icon class="admin-color">query_stats</mat-icon>{{ 'MAIN.APP.SIDEBAR.MONITORING' | translate }}
                      </a>
                      <a mat-list-item routerLink="/monitoring/api_history" routerLinkActive="active" (click)="shouldCloseSidebar.emit()" queryParamsHandling="preserve">
                        <mat-icon class="admin-color">history_edu</mat-icon>{{ 'MAIN.APP.SIDEBAR.MONITORING.API' | translate }}
                      </a>
                      <a mat-list-item routerLink="/monitoring/costs" routerLinkActive="active" (click)="shouldCloseSidebar.emit()" queryParamsHandling="preserve">
                        <mat-icon class="admin-color">credit_card_gear</mat-icon>{{ 'MAIN.APP.SIDEBAR.MONITORING.COSTS' | translate }}
                      </a>
                      <a mat-list-item routerLink="/monitoring/billing" routerLinkActive="active" (click)="shouldCloseSidebar.emit()" queryParamsHandling="preserve">
                        <mat-icon class="admin-color">receipt_long</mat-icon>{{ 'MAIN.APP.SIDEBAR.MONITORING.BILLING' | translate }}
                      </a>
                      <a mat-list-item routerLink="/monitoring/messages" routerLinkActive="active" (click)="shouldCloseSidebar.emit()" queryParamsHandling="preserve">
                        <mat-icon class="admin-color">campaign</mat-icon>{{ 'MAIN.APP.SIDEBAR.MONITORING.MEDIEGO_MESSAGES' | translate }}
                      </a>
                      <a mat-list-item routerLink="/monitoring/tracking" routerLinkActive="active" (click)="shouldCloseSidebar.emit()" queryParamsHandling="preserve">
                        <mat-icon class="admin-color">ads_click</mat-icon>{{ 'MAIN.APP.SIDEBAR.MONITORING.TRACKING' | translate }}
                      </a>
                      <a mat-list-item routerLink="/configuration/tmp-file-upload" routerLinkActive="active" (click)="shouldCloseSidebar.emit()" queryParamsHandling="preserve">
                        <mat-icon class="admin-color">cloud_upload</mat-icon>{{ 'MAIN.APP.SIDEBAR.CONFIGURATION.TMP_FILE_UPLOAD' | translate }}
                      </a>
                    }
                  }
                  <!-- END: STATIC ITEMS -->
                  @if (canMoveFolder) {
                    <div cdkDropListGroup>
                      <!-- FOLDERS -->
                      @for (folder of tab.folders | sortFolders:'asc'; track folderTrackingFunction(i, folder); let i = $index) {
                        <!-- each folder is a drop area -->
                        <div cdkDropList
                          (cdkDropListDropped)="dropInFolder($event, folder)"
                          (cdkDropListEntered)="dropPreviewInFolder($event, folder)"
                          (cdkDropListExited)="dropPreviewOutFolder($event, folder)"
                          class="folder-drop-area">
                          <a mat-list-item class="folder-link"
                            [attr.data-intercom-target]="folder.intercomTarget"
                            (click)="selectFolder(folder)">
                            <span fxLayoutAlign="start center">
                              @if (folderHovered === folder) {
                                <mat-icon class="folder-icon">folder_open</mat-icon>
                              } @else {
                                <mat-icon class="folder-icon">{{ folder.icon || 'folder' }}</mat-icon>
                              }
                              {{ folder.name | translate }}
                            </span>
                          </a>
                        </div>
                      }
                      <!-- ITEMS -->
                      @if (getSortedFolderItemsWithRouterLinks(tab) | async; as sortedItems) {
                        <div cdkDropList id="draggableItems"
                          >
                          @for (item of sortedItems; track itemTrackingFunction($index, item)) {
                            <div cdkDrag [cdkDragData]="item" (cdkDragStarted)="dragStart($event)" (cdkDragEnded)="dragEnd($event)">
                              <a mat-list-item>
                                {{ item.displayName ? item.displayName : item.name }}
                              </a>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  } @else {
                      <!-- FOLDERS WITH NO DRAG AND DROP ENABLED -->
                      @for (folder of tab.folders | orderByKey:'priority'; track folder) {
                        <a mat-list-item class="folder-link" [attr.data-intercom-target]="folder.intercomTarget" (click)="selectFolder(folder)">
                          <span fxLayoutAlign="start center">
                            <mat-icon class="folder-icon">{{ folder.icon || 'folder' }}</mat-icon>
                            {{ folder.name | translate }}
                          </span>
                          <mat-icon class="folder-arrow">chevron_right</mat-icon>
                        </a>
                      }
                      <!-- ITEMS -->
                      @if (getSortedFolderItemsWithRouterLinks(tab) | async; as sortedItems) {
                        @for (item of sortedItems; track item.id) {
                          <a mat-list-item (click)="shouldCloseSidebar.emit()" [routerLink]="item.routerLink" queryParamsHandling="preserve">
                            {{ item.displayName ? item.displayName : item.name }}
                          </a>
                        }
                      }
                    } <!-- end of drag & drop -->
                    <!-- LOGOUT -->
                    @if (tab.name === 'SHARED.BUTTONS.HOME') {
                      <a mat-list-item class="primary" routerLink="/user" (click)="shouldCloseSidebar.emit()" queryParamsHandling="preserve">
                        <mat-icon>account_circle</mat-icon>{{ 'MAIN.APP.SIDEBAR.ACCOUNT' | translate }}
                      </a>
                      <hr>
                      <a mat-list-item routerLink="/logout" (click)="shouldCloseSidebar.emit()">
                        <mat-icon>exit_to_app</mat-icon>{{ 'MAIN.APP.SIDEBAR.LOGOUT' | translate }}
                      </a>
                    }
                  </mat-nav-list>
                }
              }
            </ng-template>
          </mat-tab>
        }
      </mat-tab-group>
    </div>
  }
